import cx from 'classnames';
import React from 'react';
import type { HTMLAttributes, ReactElement } from 'react';
import { Device } from '../../device';
import { Theme } from '../../theme';
import { Grid } from '../grid';
import { Ornamentation } from './ornamentation';

export const LayoutNew = ({ className, children, version }: LayoutNew.Props): ReactElement => {
  const viewport = Theme.useViewport();
  const isDesktop = Device.isDesktop(viewport);

  return (
    <Grid
      className={cx('min-vh-100', 'bg-light', className)}
      gridTemplateColumns={isDesktop ? '.5fr .5fr' : '1fr'}
    >
      <div className='d-flex flex-column'>
        <div className='p-32px my-auto'>
          <img
            style={{ width: '160px' }}
            className='d-block d-lg-none mx-auto mb-24px'
            src='assets/entrance-dark.svg'
            alt='LiveControl Logo'
          />

          {children}

          <div className='mt-16px text-center text-secondary font-size-13px'>
            Don&lsquo;t have an account?{' '}
            <a className='' href='https://www.livecontrol.io/lead'>
              Get a demo.
            </a>
          </div>
        </div>
        {version && <div className='pl-16px pb-16px'>
          <span style={{ color: '#9B9B9B' }}>v{ version }</span>
        </div>}
      </div>
      {isDesktop && <Ornamentation />}
    </Grid>
  );
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace LayoutNew {
  export type Props = React.PropsWithChildren<HTMLAttributes<HTMLDivElement>> & { version?: string };
}
